import nl from './language/nl';

/**
 * This object is injected into the video.js player as default options.
 */
const getPlayerOptions = (type) => {
  const isVideo = type === 'video';
  return {
    language: 'nl',
    languages: {
      nl,
    },
    autoplay: false,
    controls: true,
    resizeManager: false,
    // not in MVP
    loadingSpinner: false,
    bigPlayButton: isVideo,
    controlBar: {
      fullscreenToggle: isVideo,
      currentTimeDisplay: true,
      timeDivider: true,
      durationDisplay: true,
      remainingTimeDisplay: false,
      liveDisplay: false,
      chaptersButton: false,
      captionsButton: false,
      audioTrackButton: false,
      descriptionsButton: false,
      playbackRateMenuButton: false,
      volumePanel: {
        inline: false,
        vertical: true,
      },
      progressControl: {
        seekBar: {
          loadProgressBar: false,
          mouseTimeDisplay: true,
          playProgressBar: true,
        },
      },
    },
    errorDisplay: false,
    textTrackSettings: false,
    audioTracks: true,
  };
};

export default getPlayerOptions;
